module.exports = __webpack_public_path__ + "static/media/entregapapasmini.adad4f5d.jpg";